<advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="Land Record Updatation ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}" *ngIf="showLandRecordDataTable">

  <!-- <input type="month" id="start" name="start" min="2022-01" [max]="maxDate" [(ngModel)]="currentDate" #date1 style="
  height: 35px;
    border-color: rgb(223, 223, 223);
    box-shadow: 0 2px 3px 0 rgba(179, 179, 179, 0.2), 0 3px rgba(177, 177, 177, 0.19);
    border-radius: 4px;
    border-left: 0px solid rgb(223, 223, 223);
    border-right: 0px solid rgb(223, 223, 223); 
    border-top: 1px solid rgb(236, 236, 236); 
    border-bottom: 0px solid rgb(223, 223, 223);
  ">

  <button class="ml-10px mybutton" (click)="submitDates()">Submit</button> -->

  <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>

  <span *ngIf="showSelectedDate && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;      <img src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px" (click)="closeButtonClick()">
</span>

  <div class="flex-between align-start" *ngIf="iscredCount; else elseBlock">
  </div>

 

  

  <ng-template #elseBlock>
    <div class="float-left">
      <button class="mybutton" *ngIf="!reportLink" (click)="getLogReport()">View Log Report</button>
    </div>
  </ng-template>


  <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
  <br>
  <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>

  <div *ngIf="!noUserFound" child-container class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Name</th>
          <th>Account <br> No.</th>
          <th>Sanctioned<br>Limit</th>
          <th>Due date <br> of Renewal</th>
          <th>Consent <br> Status</th>
          <th class="text-center">Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let user of allUsers;let i = index;">


          <!-- <div  > -->

          <td class="vertical-align-middle">{{10 *(pageId-1)+i+1}}</td>
          <td class="vertical-align-middle w-16pct">{{user.profile.name}}</td>
          <td><p>{{user?.user_docs?.kcc_acc_no_unMasked}}</p></td>
          <td><p>{{user?.user_docs?.existing_loan_details.existing_limit}}</p></td>
          <td><p>{{user?.user_docs?.renewal_duedate_for_credit_limit}}</p></td>
          <!-- <td onMouseOver="this.style.color='blue'" onMouseOut="this.style.color='black'" class="font-bold text-center cursor-pointer"
           
            (click)="openConsent(user.id,user.consent_feedback_status)"> -->
            <td>
            <p>{{checkConsentStatus(i)}}</td>


          <td class="vertical-align-middle p-4px text-center">
            <a class="text-no-decoration cursor-pointer" color="primary" target="_blank"
              (click)="openCust(user.id,user.profile.name,user.custId,user.isApplicant,user.is_Validated,user.profile.email,user.isCan,user.paymentStatus,user.paymentId,user.isRetail)">Land Records</a>
          </td>

        </tr>
      </tbody>
    </table>
  </div>

  <nav class="flex-center" *ngIf="totalPage>1" aria-label="Page navigation example">
    <ul class="pagination">
      <!-- limit - 10 -->
      <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
      <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
      <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
      <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a></li>
      <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page + 2}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
    </ul>
  </nav>


</wl-card>





<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />
<!-- <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"> -->